'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _slicedToArray = require('@babel/runtime/helpers/slicedToArray');
var react = require('react');
var PropTypes = require('prop-types');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var _slicedToArray__default = /*#__PURE__*/_interopDefault(_slicedToArray);
var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var DEFAULT_TIMEOUT = 15000;
var useTimeout = function useTimeout() {
  var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_TIMEOUT;
  var timeoutCallback = arguments.length > 1 ? arguments[1] : undefined;
  var _useState = react.useState(false),
    _useState2 = _slicedToArray__default.default(_useState, 2),
    timeoutOccurred = _useState2[0],
    setTimeoutOccurred = _useState2[1];
  react.useEffect(function () {
    var timerId = setTimeout(function () {
      if (timeoutCallback) {
        timeoutCallback();
      }
      setTimeoutOccurred(true);
    }, timeout);
    return function () {
      return clearTimeout(timerId);
    };
  }, [timeout]);
  return timeoutOccurred;
};
useTimeout.propTypes = {
  timeout: PropTypes__default.default.number,
  timeoutCallback: PropTypes__default.default.func
};
var useTimeout$1 = useTimeout;

exports.default = useTimeout$1;
//# sourceMappingURL=useTimeout.js.map
